<!--面板组件-->

<template>
  <PanelV2
    type="w6"
    title="Please prepare the following documents"
    @prevClick="$emit('prevClick')"
    @nextClick="$emit('nextClick')"
  >
    <template v-slot:content-solt>
      <div class="outside_box">
        <div class="Card_box">
          <div class="Card_img">
            <img src="@/assets/pc/Illustration - ID@3x.png" />
          </div>
          <div class="Card_contents">
            <p class="Card_name">
              {{ $t("APP-FIELD-0255") }}
            </p>
            <p class="Card_list" @click="openList">
              {{ $t("APP-FIELD-0256") }}
            </p>
          </div>
        </div>
        <div class="Card_box" v-if="process == 3 || process == 4">
          <div class="Card_img">
            <img src="@/assets/pc/Illustration - Document@3x.png" />
          </div>
          <div class="Card_contents">
            <p class="Card_name2">{{ $t("APP-FIELD-0152") }}</p>
          </div>
        </div>
        <div class="Card_box" v-if="process == 2">
          <div class="Card_img">
            <img src="@/assets/pc/Illustration - Document@3x.png" />
          </div>
          <div class="Card_contents">
            <p class="Card_name2">{{ $t("APP-FIELD-0257") }}</p>
          </div>
        </div>
      </div>

      <!-- 模态框 -->
      <DialogV1 v-if="showDialog" @closeDialog="closeDialog">
        <template v-slot:dia-content-title> Acceptable IDs </template>
        <template v-slot:dia-content-solt>
          <ul>
            <li>Driver's License</li>
            <li>Passport</li>
            <li>Tax Identification Number (TIN) ID</li>
            <li>Social Security System (SSS) ID</li>
            <li>Government Service and Insurance (GSIS) eCard</li>
            <li>Unified ID Multi-Purpose Identity Card (UMID)</li>
            <li>Philippine Identification System ID (Philsys)</li>
            <li>Voter's ID</li>
            <li>Philippine Postal ID</li>
            <li>Professional Regulations Commission (PRC) ID</li>
            <li>Philhealth ID</li>
            <!-- <li>
              Health Insurance Card ng Bayan issued by PhilHealth Insurance
              Corporation
            </li>
            <li>Overseas Workers Welfare Administration (OWWA) ID</li>
            <li>Overseas Filipino Workers (OFW) ID</li>
            <li>Seaman's Book</li>
            <li>
              Government Office and GOCC ID (e.g. Armed Forces of the
              Philippines [AFP}, Home Development)
            </li>
            <li>Driver's License</li>
            <li>Passport</li>
            <li>Philippine Postal ID</li>
            <li>Senior Citizen ID</li>
            <li>PRC ID</li>
            <li>SSS / GSIS ID</li>
            <li>TIN ID</li>
            <li>Voter's ID</li>
            <li>NBI Clearance</li>
            <li>Police Clearance with dry seal of PNP</li>
            <li>
              Barangay Certification with dry seal from the barangay where it
              was issued
            </li>
            <li>
              Health Insurance Card ng Bayan issued by PhilHealth Insurance
              Corporation
            </li>
            <li>Overseas Workers Welfare Administration (OWWA) ID</li>
            <li>Overseas Filipino Workers (OFW) ID</li>
            <li>Seaman's Book</li> -->
          </ul>
        </template>
      </DialogV1>
    </template>
  </PanelV2>
</template>


<script>
import PanelV2 from "./PanelV2";
import DialogV1 from "./DialogV1";

export default {
  name: "Requirements",
  components: {
    PanelV2,
    DialogV1,
  },
  data() {
    return {
      showDialog: false,
    };
  },
  methods: {
    openList() {
      this.showDialog = true;
    },
    closeDialog() {
      this.showDialog = false;
    },
  },
  props: ["process"],
};
</script>

<style lang="scss" scoped>
.panel-v2 {
  min-height: 513px;
}
.panel-v2.content-area  {
  ::v-deep .content {
    padding: 16px 0 0;
  }
}
.outside_box {
  width: 100%;
  min-height: 300px;

  img {
    width: 111.99px;
  }

  .Card_box {
    height: 112px;
    // width: 545px;
    display: flex;
    margin-bottom: 16px;

    // &:last-of-type {
    //   margin-bottom: 200px;
    // }
    .Card_img {
      width: 112px;
      height: 112px;
      margin-left: -16px;
      // border: 1px solid pink;
      // background-color: whitesmoke;
    }
    .Card_contents {
      font-family: Nunito-bold;
      margin-left: 6px;
      .Card_name {
        color: #2e2e2e;
        font-size: 20px;
        // font-weight: bold;
        margin: 32px 0 6px 0;
      }
      .Card_name2 {
        color: #2e2e2e;
        font-size: 20px;
        // font-weight: bold;
        line-height: 112px;
      }
      .Card_list {
        color: #0072d8;
        font-size: 16px;
        // font-weight: 600;
        cursor: pointer;
      }
    }
  }
  .dia_content{
    height: 300px !important;
  }
}
</style>
